import { parseAsString, useQueryState } from 'nuqs';

export function usePendingShipmentListFilter() {
  const [search, setSearch] = useQueryState('search', parseAsString.withDefault(''));

  return {
    setSearch,
    search,
  };
}
